module.exports = __webpack_public_path__ + "img/bg3.3cb967c2.jpg";